const showStoryDetails = {
    $trigger: $('.js-story-trigger'),
    init: function () {
        this.$trigger.each(function () {
            const $trigger = $(this)
            const $details = $trigger.prev('.js-story-details')
            const $gsapParent = $trigger.closest('.js-gsap-single')

            $trigger.on('click', () => {
                $trigger.toggleClass('is-clicked')
                $details.slideToggle(400, () => {
                    $gsapParent.trigger('update:height')
                })
            })
        })
    },
}

showStoryDetails.init()
